import {ReportSummary} from "../../model/report/ReportSummary";
import {PageMetadata} from "../../model/PageMetadata";
import {CacheState} from "./CacheState";

export class ReportListState implements CacheState {
    constructor(public reportSummaries: ReportSummary[] = [],
                public pageMetadata: PageMetadata = new PageMetadata(),
                public pendingRequest: boolean = false,
                public loaded: boolean = false) {}
}